import { Component, OnInit, Optional, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { AddDateFormatDialogComponent } from '../add-date-format-dialog/add-date-format-dialog.component';

@Component({
  selector: 'add-hot-alert-dailog',
  templateUrl: './add-hot-alert-dailog.component.html',
  styleUrls: ['./add-hot-alert-dailog.component.scss']
})
export class AddHotAlertDailogComponent implements OnInit {

  strHotAlert: string;
  constructor(
    public dialogRef: MatDialogRef<AddDateFormatDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA)
    public dialog: MatDialog
  ) {
    dialogRef.disableClose = true;
  }

  ngOnInit() {

    //this.strHotAlert = this.arrDateFormatMappingDetail.format;
  }

  onNoClick(): void {
   // this.dialogRef.close({ format: this.format });
  }

}
